<script setup lang="ts">
import BaseIcon from "@/library/BaseIcon.vue";
import type { BaseIconName } from "@/library/baseIconTypes.ts";

export type MedallionColor =
  | "cloaked"
  | "spirit-rose"
  | "arctic-lime"
  | "foam-blue"
  | "crest-blue"
  | "violet-reflection"
  | "caribbean-green"
  | "spam-protection"
  | "safe-zone-blue"
  | "safe-zone-green";

type BaseMedallionProps = {
  icon: BaseIconName;
  size?: "md" | "lg";
  color?: MedallionColor;
};

withDefaults(defineProps<BaseMedallionProps>(), {
  size: "md",
  color: "safe-zone-blue",
});
</script>

<template>
  <div class="base-medallion">
    <div
      class="base-medallion__button"
      :class="[
        `base-medallion__button--${size}`,
        `base-medallion__button--${color}`,
      ]"
    >
      <BaseIcon
        :name="icon"
        class="base-medallion__button-icon"
        :class="[`base-medallion__button-icon--${color}`]"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.base-medallion {
  &__button {
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &-icon {
      color: $white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
    }

    &--md {
      width: 48px;
      height: 48px;

      .base-medallion__button-icon {
        width: 36px;
        height: 36px;
        font-size: 18px;
      }
    }

    &--lg {
      width: 80px;
      height: 80px;

      .base-medallion__button-icon {
        width: 56px;
        height: 56px;
        font-size: 36px;
      }
    }

    &--cloaked {
      background-color: rgba($color-cloaked, 0.15);

      .base-medallion__button-icon--cloaked {
        background-color: $color-cloaked;
      }
    }

    &--spirit-rose {
      background-color: rgba($color-spirit-rose, 0.15);

      .base-medallion__button-icon--spirit-rose {
        background-color: $color-spirit-rose;
      }
    }

    &--arctic-lime {
      background-color: rgba($color-arctic-lime, 0.15);

      .base-medallion__button-icon--arctic-lime {
        background-color: $color-arctic-lime;
      }
    }

    &--foam-blue {
      background-color: rgba($color-foam-blue, 0.15);

      .base-medallion__button-icon--foam-blue {
        background-color: $color-foam-blue;
      }
    }

    &--crest-blue {
      background-color: rgba($color-crest-blue, 0.15);

      .base-medallion__button-icon--crest-blue {
        background-color: $color-crest-blue;
      }
    }

    &--violet-reflection {
      background-color: rgba($color-violet-reflection, 0.15);

      .base-medallion__button-icon--violet-reflection {
        background-color: $color-violet-reflection;
      }
    }

    &--caribbean-green {
      background-color: rgba($color-caribbean-green, 0.15);

      .base-medallion__button-icon--caribbean-green {
        background-color: $color-caribbean-green;
      }
    }

    &--spam-protection {
      background-color: rgba($color-spam-protection, 0.15);

      .base-medallion__button-icon--spam-protection {
        background-color: $color-spam-protection;
      }
    }

    &--safe-zone-blue {
      background-color: rgba($color-safe-zone-blue, 0.15);

      .base-medallion__button-icon--safe-zone-blue {
        background-color: $color-safe-zone-blue;
      }
    }

    &--safe-zone-green {
      background-color: rgba($color-safe-zone-green, 0.15);

      .base-medallion__button-icon--safe-zone-green {
        background-color: $color-safe-zone-green;
      }
    }
  }
}
</style>
